// Auto-generado por @xone-web/staticweb a partir de LoginColl.xne.
// NO EDITAR: se regenera en cada build.
// Eventos lifecycle + custom + sintéticos (onclick/onchange por prop).

import type { XoneAPI } from "../xone-api";
import type { LoginCollFields } from "./LoginColl.types";
export async function beforeEdit(api: XoneAPI<LoginCollFields>): Promise<unknown> {
    const { self, This, ThisDataColl, ui, appData, $http, crypto, Bundle, console } = api;
    void self; void This; void ThisDataColl; void ui; void appData; void $http; void crypto; void Bundle; void console;
    
    ui.setSessionExpired(900000,logout);
}
export async function afterEdit(api: XoneAPI<LoginCollFields>): Promise<unknown> {
    const { self, This, ThisDataColl, ui, appData, $http, crypto, Bundle, console } = api;
    void self; void This; void ThisDataColl; void ui; void appData; void $http; void crypto; void Bundle; void console;
    
    self.setFieldPropertyValue("BTVERSION", "title", "Versi�n: " + appData.getGlobalMacro("##VERSION##"));
}
export async function login(api: XoneAPI<LoginCollFields>): Promise<unknown> {
    const { self, This, ThisDataColl, ui, appData, $http, crypto, Bundle, console } = api;
    void self; void This; void ThisDataColl; void ui; void appData; void $http; void crypto; void Bundle; void console;
    
    var params = {
                        userName: self.USER,
                        password: self.PWD,
                        entryPoint: "Inicio",
                
                        // Opcional
                        onLoginSuccessful: function() {
                             ui.showToast("Login OK!");
                        },  
                
                        // Opcional
                        onLoginFailed: function() {
                            ui.showToast("Login failed!");
                        }
                    };
                    appData.login(params);
}
export async function onback(api: XoneAPI<LoginCollFields>): Promise<unknown> {
    const { self, This, ThisDataColl, ui, appData, $http, crypto, Bundle, console } = api;
    void self; void This; void ThisDataColl; void ui; void appData; void $http; void crypto; void Bundle; void console;
    
    appData.failWithMessage(-11888,"##EXITAPP##");
}